<div class="search-employees">
  <div class="teams">
    <gp-dropdown-select #ddown
                        [ngModel]="selectedTeam"
                        [buttonClasses]="['no-borders']"
                        [attr.test-id]="'team-select'"
                        class="search-inputs form-control normal-wrap no-border team-planning"
                        (ngModelChange)="changeTeam($event)">
      <gp-dropdown-option [ngValue]="0" [attr.test-id]="'direct-subordinates'">
        {{ 'TEAM_PLANNING.direct_subordinates' | translate }}
      </gp-dropdown-option>
      <gp-dropdown-option [ngValue]="1" [attr.test-id]="'indirect-subordinates'">
        {{ 'TEAM_PLANNING.indirect_subordinates' | translate }}
      </gp-dropdown-option>
      <gp-dropdown-option [ngValue]="2" [attr.test-id]="'future-subordinates'">
        {{ 'TEAM_PLANNING.future_subordinates' | translate }}
      </gp-dropdown-option>
      <gp-dropdown-option [ngValue]="3" [attr.test-id]="'backup-subordinates'">
        {{ 'TEAM_PLANNING.backup_subordinates' | translate }}
      </gp-dropdown-option>
      <gp-dropdown-option [ngValue]="4" [attr.test-id]="'all-subordinates'">
        {{ 'TEAM_PLANNING.all_subordinates' | translate }}
      </gp-dropdown-option>
      <hr *ngIf="teams.length > 0" class="button-separator">
      <gp-dropdown-option  *ngFor="let team of teams"
                           [ngValue]="team.id">
        {{team.name}}
      </gp-dropdown-option>
      <hr class="button-separator">
      <p (click)="openCreateTeamModal(); ddown.open = false;" class="text-primary" [attr.test-id]="'create-new-team'">
        {{ 'TEAM_PLANNING.create_new_team' | translate }}
      </p>
      <p *ngIf="isCustomTeam" (click)="deleteTeam(); ddown.open = false;" class="text-primary" [attr.test-id]="'delete-team'">
        {{ 'TEAM_PLANNING.delete_team' | translate }}
      </p>
    </gp-dropdown-select>
  </div>
  <div #filter>
    <div class="search-team">
      <span *ngIf="!isCustomTeam else disabledFilter" class="no-border no-bg"><i class="fa fa-light fa-search" aria-hidden="true"></i></span>
      <ng-template #disabledFilter>
        <span class="no-border no-bg"><i class="fa fa-light fa-filter-circle-xmark" aria-hidden="true"></i></span>
      </ng-template>
      <input type="text" class="search-inputs form-control no-border no-bg line-height-1"
             placeholder="{{ 'NAVBAR.search' | translate }}..."
             [formControl]="searchTermControl"
             [patterns]="allCharsExceptSimpleQuoteGroupMaskPatterns"
             [mask]="'L*'"
             [attr.test-id]="'search-term'"
             [dropSpecialCharacters]="false">
    </div>
  </div>
</div>
